import React from 'react'
import styled from 'styled-components'

export const BodyWrapper = styled.div`
  border-radius: 24px;
  background: #1E1F20;
  border: 1px solid #DAA10E;
  max-width: 436px;
  width: 100%;
  z-index: 1;
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  return <BodyWrapper>{children}</BodyWrapper>
}
